/**
 * Master Data B permission keys used by the UI (catalog `md.<feature>.<action>`; legacy menus 30 Item, 31 Warehouse,
 * 37 Inventory Lookups, 39 Service Price, 159 Print Items Barcode, 217 Item Quick Update, 305 Item Unit Group). The API
 * checks the same keys.
 */
export const catalogPermissions = {
  itemView: "md.item.view",
  itemCreate: "md.item.create",
  itemUpdate: "md.item.update",
  itemDelete: "md.item.delete",
  itemImport: "md.item.import",
  itemExport: "md.item.export",
  itemDefaultSettings: "md.item.control.btn_default_settings",
  quickUpdateView: "md.item_quick_update.view",
  quickUpdateUpdate: "md.item_quick_update.update",
  barcodePrint: "md.item_barcode_print.print",
  barcodeGenerate: "md.item_barcode_print.update",
  lookupView: "md.lookup.view",
  lookupCreate: "md.lookup.create",
  lookupUpdate: "md.lookup.update",
  lookupDelete: "md.lookup.delete",
  lookupImport: "md.lookup.import",
  lookupExport: "md.lookup.export",
  unitGroupView: "md.unit_group.view",
  unitGroupCreate: "md.unit_group.create",
  unitGroupUpdate: "md.unit_group.update",
  unitGroupDelete: "md.unit_group.delete",
  accountFamilyView: "md.account_family.view",
  accountFamilyCreate: "md.account_family.create",
  accountFamilyUpdate: "md.account_family.update",
  accountFamilyDelete: "md.account_family.delete",
  warehouseView: "md.warehouse.view",
  warehouseCreate: "md.warehouse.create",
  warehouseUpdate: "md.warehouse.update",
  warehouseDelete: "md.warehouse.delete",
  warehouseImport: "md.warehouse.import",
  warehouseExport: "md.warehouse.export",
  priceListView: "md.price_list.view",
  priceListCreate: "md.price_list.create",
  priceListUpdate: "md.price_list.update",
  priceListDelete: "md.price_list.delete",
  priceListImport: "md.price_list.import",
  priceListExport: "md.price_list.export",
  serviceTariffView: "md.service_tariff.view",
  serviceTariffCreate: "md.service_tariff.create",
  serviceTariffUpdate: "md.service_tariff.update",
  serviceTariffDelete: "md.service_tariff.delete",
} as const;
